import React, {Component} from 'react'
import {downLoadVisit} from "../data/analytics";

export class demoVideos extends Component {
	render() {
		return (
			<div className={"app-container"} id="demo">
				<div className="container">
					<div className="row">
						<div className="col-xs-12">
							<div className="text-center">
								<h2 className={"section-title"}>
									See the app in action
								</h2>
								<div className="row pt-5 pb-5">
									<div className="col-md-4 mb-5">
										<iframe
											className={"fb-video"}
											src="https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Fmyhrsapp%2Fvideos%2F430538235345298%2F&show_text=false&width=476&t=0"
											width="380" height="380" scrolling="no" frameBorder="0"
											allowFullScreen="true"
											allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
											allowFullScreen="true"></iframe>
									</div>

									<div className="col-md-4 mb-5">
										<iframe
											className={"fb-video"}
											src="https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Fmyhrsapp%2Fvideos%2F882248269096762%2F&show_text=false&width=476&t=0"
											width="380" height="380" scrolling="no" frameBorder="0"
											allowFullScreen="true"
											allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
											allowFullScreen="true"></iframe>
									</div>

									<div className="col-md-4 mb-5">
										<iframe
											className={"fb-video"}
											src="https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Fmyhrsapp%2Fvideos%2F470292344310557%2F&show_text=false&width=476&t=0"
											width="380" height="380" scrolling="no" frameBorder="0"
											allowFullScreen="true"
											allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
											allowFullScreen="true"></iframe>
									</div>


										<div className="col-md-4 mb-5">
											<iframe
												className={"fb-video"}
												src="https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Fmyhrsapp%2Fvideos%2F2648416948800508%2F&show_text=false&width=476&t=0"
												width="380" height="380" scrolling="no" frameBorder="0"
												allowFullScreen="true"
												allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
												allowFullScreen="true"></iframe>
										</div>

										<div className="col-md-4 mb-5">
											<iframe
												className={"fb-video"}
												src="https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Fmyhrsapp%2Fvideos%2F439691380905216%2F&show_text=false&width=476&t=0"
												width="380" height="380" scrolling="no" frameBorder="0"
												allowFullScreen="true"
												allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
												allowFullScreen="true"></iframe>
										</div>
								</div>


							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default demoVideos



// WEBPACK FOOTER //
// ./src/components/demoVideos.jsx